import { render } from "./um_class_add.vue?vue&type=template&id=2addb298"
import script from "./um_class_add.vue?vue&type=script&lang=js"
export * from "./um_class_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__